var _path, _path2, _path3, _path4, _path5, _path6, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 9.83594H6.08696C4.93436 9.83594 4 10.7703 4 11.9229V20.1719C4 21.8287 5.34315 23.1719 7 23.1719H25C26.6569 23.1719 28 21.8287 28 20.1719V12.8359C28 11.1791 26.6569 9.83594 25 9.83594Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.468 16.1473C10.6627 16.342 10.6627 16.6593 10.468 16.854C10.2733 17.0487 9.956 17.0487 9.76133 16.854C9.56666 16.6593 9.56666 16.342 9.76133 16.1473C9.956 15.9513 10.272 15.9513 10.468 16.1473",
    stroke: "#E3E7EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3533 16.1473C16.5479 16.342 16.5479 16.6593 16.3533 16.854C16.1586 17.0487 15.8413 17.0487 15.6466 16.854C15.4519 16.6593 15.4519 16.342 15.6466 16.1473C15.8413 15.9513 16.1586 15.9513 16.3533 16.1473",
    stroke: "#E3E7EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 4.5H18.6666C20.1399 4.5 21.3333 5.69333 21.3333 7.16667C21.3333 5.69333 22.5266 4.5 23.9999 4.5H25.3333",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 25.8332V7.1665",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 28.5002H23.9999C22.5266 28.5002 21.3333 27.3068 21.3333 25.8335C21.3333 27.3068 20.1399 28.5002 18.6666 28.5002H17.3333",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8.5,
    width: 2.32812,
    height: 16,
    fill: "#E3E7EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.b93cf3323c12118bc995d90ca054a903.svg";
export { ForwardRef as ReactComponent };